import * as React from "react";
import { useId } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconSuccess = (props) => {
	const __svgrId = useId();
	return /* @__PURE__ */ _jsxs("svg", {
		viewBox: "0 0 44 44",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		...props,
		children: [/* @__PURE__ */ _jsxs("g", {
			filter: `url(#${__svgrId}-filter0_ii_2796_1682)`,
			children: [/* @__PURE__ */ _jsx("rect", {
				width: 44,
				height: 44,
				rx: 12,
				fill: "#D1D7B3"
			}), /* @__PURE__ */ _jsxs("g", {
				filter: `url(#${__svgrId}-filter1_d_2796_1682)`,
				children: [/* @__PURE__ */ _jsx("path", {
					d: "M17.3779 23.1008L15.3697 20.6818C14.3374 19.4383 12.489 19.2755 11.2552 20.3194C10.0373 21.3499 9.8774 23.1694 10.8969 24.3965L14.8743 29.1838C16.1803 30.7557 18.5178 30.9602 20.0769 29.639L33.3102 18.4245C34.4655 17.4455 34.6161 15.7184 33.6478 14.5542C32.6666 13.3744 30.9115 13.2215 29.7411 14.2139L19.0834 23.2501C18.5723 23.6834 17.8059 23.6163 17.3779 23.1008Z",
					fill: "#D1D7B3",
					stroke: "white",
					strokeWidth: 5.5
				}), /* @__PURE__ */ _jsx("path", {
					d: "M17.3779 23.1008L15.3697 20.6818C14.3374 19.4383 12.489 19.2755 11.2552 20.3194C10.0373 21.3499 9.8774 23.1694 10.8969 24.3965L14.8743 29.1838C16.1803 30.7557 18.5178 30.9602 20.0769 29.639L33.3102 18.4245C34.4655 17.4455 34.6161 15.7184 33.6478 14.5542C32.6666 13.3744 30.9115 13.2215 29.7411 14.2139L19.0834 23.2501C18.5723 23.6834 17.8059 23.6163 17.3779 23.1008Z",
					fill: "#D1D7B3",
					stroke: "#7A9033",
					strokeWidth: 1.5
				})]
			})]
		}), /* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("filter", {
			id: `${__svgrId}-filter0_ii_2796_1682`,
			x: 0,
			y: 0,
			width: 44,
			height: 44,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "BackgroundImageFix",
					result: "shape"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feMorphology", {
					radius: 1,
					operator: "erode",
					in: "SourceAlpha",
					result: "effect1_innerShadow_2796_1682"
				}),
				/* @__PURE__ */ _jsx("feOffset", {}),
				/* @__PURE__ */ _jsx("feComposite", {
					in2: "hardAlpha",
					operator: "arithmetic",
					k2: -1,
					k3: 1
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "shape",
					result: "effect1_innerShadow_2796_1682"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", { dy: -1 }),
				/* @__PURE__ */ _jsx("feComposite", {
					in2: "hardAlpha",
					operator: "arithmetic",
					k2: -1,
					k3: 1
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "effect1_innerShadow_2796_1682",
					result: "effect2_innerShadow_2796_1682"
				})
			]
		}), /* @__PURE__ */ _jsxs("filter", {
			id: `${__svgrId}-filter1_d_2796_1682`,
			x: 6.47559,
			y: 10.8086,
			width: 31.5605,
			height: 25.4512,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", { dy: 2 }),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: .5 }),
				/* @__PURE__ */ _jsx("feComposite", {
					in2: "hardAlpha",
					operator: "out"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0.372549 0 0 0 0 0.435294 0 0 0 0 0.152941 0 0 0 0.25 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "BackgroundImageFix",
					result: "effect1_dropShadow_2796_1682"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "effect1_dropShadow_2796_1682",
					result: "shape"
				})
			]
		})] })]
	});
};
export default SvgIconSuccess;
